import { Link } from "react-router-dom";
import { ArrowLeft, Phone, Mail } from "lucide-react";
import { SITE, INVESTMENT_DISCLAIMER } from "@/data/content";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      ["What we collect", "When you submit an enquiry through this website, we collect the details you provide: your name, phone number, email address, preferred property type, budget range and message. If you contact us via WhatsApp or phone, we receive the information you choose to share."],
      ["How we use it", "Your details are used only to respond to your enquiry — sharing property options, coordinating site visits and following up on your request. We do not sell your data to third parties."],
      ["Storage", "Enquiries are stored securely in our database and accessible only to Paras Real Estate."],
      ["Your choices", `You may ask us to update or delete your enquiry at any time. Call ${SITE.phoneDisplay} or email ${SITE.email}.`],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      ["Use of this website", "This website provides general information about Paras Real Estate and property opportunities in and around Dholera Smart City, Gujarat. By using it, you agree to these terms."],
      ["No offer or commitment", "Listings marked as samples are illustrative. Nothing on this website constitutes an offer, booking, or commitment of any property. Availability, locations and pricing are confirmed only through direct communication."],
      ["Ownership", "All content, branding and design on this website belong to Paras Real Estate and may not be reproduced without permission."],
      ["Contact", `For any questions about these terms, contact ${SITE.owner}, Paras Real Estate — ${SITE.phoneDisplay}, ${SITE.email}.`],
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    body: [
      ["General information only", INVESTMENT_DISCLAIMER],
      ["Sources", "Facts about Dholera SIR (area, expressway, airport status, distances) are drawn from public government and press sources as of 2026, including DSIRDA and PIB. Figures are approximate and may change; verify independently."],
      ["Placeholders", "Where specific project or inventory details are unavailable, this website uses clearly-labelled placeholders. These are not real listings and must not be relied upon."],
      ["No government affiliation", "Paras Real Estate is an independent property consultancy. It is not affiliated with DSIRDA, DICDL, or any government body."],
    ],
  },
};

export default function LegalPage({ kind }) {
  const page = CONTENT[kind] || CONTENT.disclaimer;
  return (
    <main className="min-h-screen bg-paper" data-testid={`legal-page-${kind}`}>
      <header className="bg-navy pt-32 pb-16">
        <div className="container-luxe">
          <Link to="/" className="inline-flex items-center gap-2 text-gold text-sm font-medium hover:text-white transition-colors duration-300" data-testid="legal-back-home">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
          <h1 className="mt-6 font-serif font-semibold text-white text-4xl sm:text-5xl tracking-tight">{page.title}</h1>
          <p className="mt-3 text-white/60 text-sm">{SITE.name} · {SITE.location}</p>
        </div>
      </header>
      <div className="container-luxe py-16 max-w-4xl">
        <div className="space-y-10">
          {page.body.map(([h, p]) => (
            <section key={h}>
              <h2 className="font-serif text-2xl text-navy font-semibold">{h}</h2>
              <p className="mt-3 text-body leading-relaxed">{p}</p>
            </section>
          ))}
        </div>
        <section className="mt-12 border-t border-border pt-8 flex flex-wrap gap-4">
          <a href={SITE.phoneHref} className="btn-navy !py-2.5"><Phone className="w-4 h-4" /> {SITE.phoneDisplay}</a>
          <a href={`mailto:${SITE.email}`} className="btn-gold !py-2.5"><Mail className="w-4 h-4" /> Email Us</a>
        </section>
      </div>
      <footer className="border-t border-border py-8 text-center text-xs text-navy/50">
        © 2026 Paras Real Estate · <Link to="/" className="underline hover:text-gold-dark">Home</Link>
      </footer>
    </main>
  );
}
